import React from 'react';
import { useTrackSection } from '../utils/useTrackSection';
const painPoints = ['El lunes a las 8:50 todavía no sabés qué protocolo vas a aplicar en la sesión de las 9. Y eso se nota en tu seguridad.', 'Tus pacientes llevan semanas en tratamiento pero no podés mostrar una evolución clara ni justificar los cambios que estás haciendo.', 'Un paciente te pregunta "¿por qué este ejercicio y no otro?" y tu respuesta no tiene el respaldo clínico que merecería tener.', 'El domingo a las 23:00 seguís armando historias clínicas desde cero, sin plantillas, sin criterio ordenado y sin tiempo para pensar.', 'Sabés que deberías cobrar más, pero no tenés un sistema profesional visible que justifique ese aumento frente a tus pacientes.', 'Cada sesión empieza desde cero. Sin protocolo, sin material listo, sin progresión medible. Y lo peor: ya te acostumbraste.'];
export function PainPoints() {
  useTrackSection('pain-points', 'Pain Points Section');
  return <section id="pain-points" className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900 text-base leading-6" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(248,250,252) 0%, rgb(254,242,242) 10%, rgb(254,242,242) 85%, rgb(255,255,255) 100%)',
    fontFamily: 'var(--font-system)'
  }} data-id="element-180">
      <div className="mx-auto max-w-4xl" data-id="element-181">
        {/* Section Title */}
        <p className="text-center text-xs sm:text-sm font-bold tracking-[2px] uppercase text-red-500 mb-2" data-id="element-182">
          ¿Te sentís identificado?
        </p>
        <h2 className="text-center text-2xl sm:text-3xl font-black text-gray-900 m-0 mb-2" data-id="element-183">
          Esto le pasa al 90% de los kinesiólogos
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-6" data-id="element-184">
          No es falta de conocimiento. Es falta de un sistema.
        </p>

        {/* Pain Points Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8" data-id="element-185">
          {painPoints.map((point, i) => <div key={i} className="flex items-start gap-2 bg-white border border-red-200 rounded-lg p-3 shadow-sm" data-id="element-186">
              <span className="text-red-500 text-base leading-5 shrink-0" data-id="element-187">
                ✗
              </span>
              <p className="text-xs sm:text-sm text-gray-800 m-0" data-id="element-188">{point}</p>
            </div>)}
        </div>

        {/* Bottom CTA */}
        <p className="text-center text-xl sm:text-2xl font-black text-red-500 m-0 mb-6" data-id="element-189">
          ¿Cuántas sesiones más vas a improvisar?
        </p>

        {/* Divider */}
        <div className="h-px w-full" style={{
        backgroundImage: 'linear-gradient(to right, rgba(255,255,255,0), rgb(0,119,182), rgba(255,255,255,0))'
      }} data-id="element-190" />
      </div>
    </section>;
}